module.exports = __webpack_public_path__ + "img/2_2_m.fa965aad.jpg";